import React from 'react'
import PropTypes from 'prop-types'
import {Button} from 'antd'
import startcase from 'lodash.startcase'
import qs from 'qs'

import {useFetch} from '../lib/use-fetch'
import Spinner from '../lib/spinner'
import OAuthError from './OAuthError'
import {FormattedMessage} from 'react-intl'
import {redirectToAuthorize} from '../utils'
import {generateAndSaveOauthState as generateAndStoreState} from '../lib/oauthState'

function SocialLogin ({appId, authorizeUrl, redirectUrl}) {
  const {loading, responseBody, status} = useFetch('GET', `/apps/${appId}/providers/`)

  if (loading) {
    return <Spinner />
  }

  if (!Array.isArray(responseBody) || responseBody.length === 0 || status !== 200) {
    return <OAuthError error='providers retrieval failed' errorDescription='' />
  }

  const buildProviderButtonOnClick = ({appId, provider}) => () => {
    const state = generateAndStoreState()
    const query = qs.stringify({
      appId,
      providerId: provider.id,
      redirect: redirectUrl,
      state
    }, {addQueryPrefix: true})

    redirectToAuthorize(query)
  }

  return (
    <div style={styles.container}>
      <h1>
        <FormattedMessage defaultMessage='Login' id='login.message' />
      </h1>
      <div style={styles.buttons}>
        {responseBody.map(provider => {
          return (
            <Button
              icon={getIconByProviderType(provider.type)}
              key={provider.id}
              onClick={buildProviderButtonOnClick({appId, provider})}
              style={{margin: 5}}
            >
              <span style={{paddingLeft: 3}}>
                {
                  provider.label ? provider.label : (
                    <FormattedMessage id='loginwith.button' values={{providerType: startcase(provider.id)}} />
                  )
                }
              </span>
            </Button>
          )
        })}
      </div>
    </div>
  )
}

function getIconByProviderType (type) {
  switch (type) {
    case 'gitlab':
      return 'gitlab'
    case 'github':
      return 'github'
    default:
      return null
  }
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    flexDirection: 'column'
  },
  buttons: {
    display: 'flex',
    flexDirection: 'column'
  }
}

SocialLogin.propTypes = {
  appId: PropTypes.string.isRequired,
  authorizeUrl: PropTypes.string.isRequired,
  redirectUrl: PropTypes.string
}

export default SocialLogin
